/**
 * 申请进度相关API接口
 */
import request from '@/utils/request'
import type {
  Application,
  ApplicationStep,
  ApiResponse,
  PaginationParams,
  PaginationResponse
} from '@/types/models'

export const applicationApi = {
  /**
   * 获取申请列表
   */
  getApplicationList(params?: PaginationParams & { status?: string; type?: string }) {
    return request<ApiResponse<PaginationResponse<Application>>>({
      url: '/api2/applications',
      method: 'get',
      params
    })
  },

  /**
   * 获取申请详情
   */
  getApplicationDetail(id: string) {
    return request<ApiResponse<Application>>({
      url: `/api2/applications/${id}`,
      method: 'get'
    })
  },

  /**
   * 创建申请
   * 注意：后端使用 json_decode(file_get_contents('php://input')) 解析，需要发送 JSON 格式
   */
  createApplication(data: {
    community_id: number
    real_name: string
    gender: string
    phone: string
    birthday: string
    id_card: string
    address: string
    age?: number
    email?: string
    education?: string
    occupation?: string
    work_experience?: string
    self_introduction?: string
    application_reason?: string
    resource_details?: string
    service_experience?: string
  }) {
    return request<ApiResponse<Application>>({
      url: '/api2/applications',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'application/json'
      },
      transformRequest: [(data) => JSON.stringify(data)]
    })
  },

  /**
   * 取消申请
   */
  cancelApplication(id: string, reason?: string) {
    return request<ApiResponse<void>>({
      url: `/api/applications/${id}/cancel`,
      method: 'post',
      data: { reason }
    })
  },

  /**
   * 获取申请步骤
   */
  getApplicationSteps(id: string) {
    return request<ApiResponse<ApplicationStep[]>>({
      url: `/api2/applications/${id}/steps`,
      method: 'get'
    })
  }
}

export default applicationApi